<div
    fxLayout="column"
    class="comments-post-dialog-component gap-16 padding-12 full-width full-height"
>
    <div fxLayout="column">
        <div
            fxLayout="row"
            class="comments-post-dialog-component__header"
            fxLayoutAlign="space-between center"
            style="height: 24px"
        >
            <h1 class="text-16-semi-bold color-text-primary">Comentários</h1>
            <dsn-button-menu-chips
                [mainIcon]="'fa-solid fa-xmark'"
                size="medium"
                (onClick)="this.dialogRef.close()"
            ></dsn-button-menu-chips>
        </div>
        <p class="color-text-primary text-14-regular">
            {{ data.visualization.props.name }}
        </p>
    </div>

    <div
        class="comments-post-dialog-component__section full-height gap-8"
        fxFlex
    >
        <app-comments-post
            [company]="data.company"
            [options]="data.options"
            [visualization]="data.visualization"
            [report]="data.report"
        ></app-comments-post>
    </div>
</div>
